export const newsletterPublicDe = {
  subscribeTitle: 'Newsletter abonnieren',
  subscribeSubtitle: 'Wählen Sie freiwillig die Themen, zu denen Sie E-Mails erhalten möchten.',
  confirmTitle: 'Anmeldung bestätigen',
  confirmSubtitle: 'Prüfen Sie die Anfrage und bestätigen Sie sie anschließend ausdrücklich.',
  preferencesTitle: 'Newsletter-Einstellungen',
  preferencesSubtitle: 'Themen, Sprache und eine gesonderte Tracking-Einwilligung verwalten.',
  email: 'E-Mail-Adresse',
  language: 'Sprache',
  topics: 'Newsletter-Themen',
  consent: 'Ich möchte die ausgewählten Newsletter erhalten und willige wie beschrieben ein.',
  privacyHeading: 'Datenschutzhinweis',
  tracking: 'Ich willige gesondert in individuelles Öffnungs- und Klicktracking ein.',
  trackingOptional: 'Diese Auswahl ist freiwillig und unabhängig vom Newsletterbezug.',
  withdrawal: 'Sie können Ihre Auswahl jederzeit ebenso einfach widerrufen.',
  noPreselection: 'Es ist nichts vorausgewählt.',
  request: 'Bestätigungs-E-Mail anfordern',
  prepare: 'Sichere Bestätigung öffnen',
  confirm: 'Newsletter-Anmeldung bestätigen',
  save: 'Einstellungen speichern',
  unsubscribe: 'Alle Newsletter abbestellen',
  unsubscribeConfirm: 'Alle Newsletter jetzt abbestellen?',
  unsubscribeDescription:
    'Die Änderung gilt sofort. Für eine spätere erneute Anmeldung ist ein neuer Double-Opt-in erforderlich.',
  cancel: 'Abbrechen',
  requested:
    'Wenn die Angaben gültig sind, wurde eine reine Bestätigungs-E-Mail versendet. Bitte prüfen Sie auch den Spam-Ordner.',
  confirmed: 'Ihre Newsletter-Anmeldung wurde bestätigt.',
  saved: 'Ihre Einstellungen wurden sofort gespeichert.',
  unsubscribed: 'Sie wurden von allen Newslettern abgemeldet.',
  loading: 'Sichere Newsletter-Seite wird geladen …',
  unavailable: 'Diese Newsletter-Seite ist nicht verfügbar oder der Zugriff ist abgelaufen.',
  chooseTopic: 'Wählen Sie mindestens ein Thema aus.',
  consentRequired: 'Die Einwilligung ist nicht vorausgewählt und muss ausdrücklich erteilt werden.',
  error: 'Die Aktion konnte nicht abgeschlossen werden. Versuchen Sie es später erneut.',
  legalReview:
    'Die technische Bereitstellung ersetzt keine rechtliche oder datenschutzrechtliche Prüfung des Angebots.',
  publishLegalTexts: 'Versionierte Rechtstexte veröffentlichen',
  embeddedForm: 'Einbettbares Anmeldeformular aktivieren',
} as const;

export const newsletterPublicEn = {
  subscribeTitle: 'Subscribe to newsletters',
  subscribeSubtitle: 'Freely choose the topics for which you would like to receive email.',
  confirmTitle: 'Confirm subscription',
  confirmSubtitle: 'Review the request and then confirm it explicitly.',
  preferencesTitle: 'Newsletter preferences',
  preferencesSubtitle: 'Manage topics, language and separate tracking consent.',
  email: 'Email address',
  language: 'Language',
  topics: 'Newsletter topics',
  consent: 'I want to receive the selected newsletters and consent as described.',
  privacyHeading: 'Privacy notice',
  tracking: 'I separately consent to individual open and click tracking.',
  trackingOptional: 'This choice is optional and independent of the newsletter subscription.',
  withdrawal: 'You can withdraw your choices at any time just as easily.',
  noPreselection: 'Nothing is preselected.',
  request: 'Request confirmation email',
  prepare: 'Open secure confirmation',
  confirm: 'Confirm newsletter subscription',
  save: 'Save preferences',
  unsubscribe: 'Unsubscribe from all newsletters',
  unsubscribeConfirm: 'Unsubscribe from all newsletters now?',
  unsubscribeDescription:
    'The change takes effect immediately. A new double opt-in is required to subscribe again later.',
  cancel: 'Cancel',
  requested:
    'If the details are valid, a confirmation-only email has been sent. Please also check the spam folder.',
  confirmed: 'Your newsletter subscription has been confirmed.',
  saved: 'Your preferences were saved immediately.',
  unsubscribed: 'You have been unsubscribed from all newsletters.',
  loading: 'Loading the secure newsletter page…',
  unavailable: 'This newsletter page is unavailable or access has expired.',
  chooseTopic: 'Select at least one topic.',
  consentRequired: 'Consent is not preselected and must be given explicitly.',
  error: 'The action could not be completed. Please try again later.',
  legalReview:
    'Technical availability does not replace legal or data-protection review of this offering.',
  publishLegalTexts: 'Publish versioned legal texts',
  embeddedForm: 'Enable embeddable subscription form',
} as const;

export const newsletterPublicTr = {
  subscribeTitle: 'Bültene abone olun',
  subscribeSubtitle: 'E-posta almak istediğiniz konuları özgürce seçin.',
  confirmTitle: 'Aboneliği onayla',
  confirmSubtitle: 'Talebi inceleyin ve ardından açıkça onaylayın.',
  preferencesTitle: 'Bülten tercihleri',
  preferencesSubtitle: 'Konuları, dili ve ayrı izleme rızasını yönetin.',
  email: 'E-posta adresi',
  language: 'Dil',
  topics: 'Bülten konuları',
  consent: 'Seçtiğim bültenleri almak istiyor ve açıklandığı şekilde rıza veriyorum.',
  privacyHeading: 'Gizlilik bildirimi',
  tracking: 'Bireysel açılma ve tıklama takibine ayrıca rıza veriyorum.',
  trackingOptional: 'Bu seçim isteğe bağlıdır ve bülten aboneliğinden bağımsızdır.',
  withdrawal: 'Seçimlerinizi istediğiniz zaman aynı kolaylıkla geri çekebilirsiniz.',
  noPreselection: 'Hiçbir seçenek önceden işaretlenmemiştir.',
  request: 'Onay e-postası iste',
  prepare: 'Güvenli onayı aç',
  confirm: 'Bülten aboneliğini onayla',
  save: 'Tercihleri kaydet',
  unsubscribe: 'Tüm bültenlerden çık',
  unsubscribeConfirm: 'Şimdi tüm bültenlerden çıkılsın mı?',
  unsubscribeDescription:
    'Değişiklik hemen geçerlidir. Daha sonra yeniden abone olmak için yeni bir çift onay gerekir.',
  cancel: 'İptal',
  requested:
    'Bilgiler geçerliyse yalnızca onay içeren bir e-posta gönderildi. Spam klasörünü de kontrol edin.',
  confirmed: 'Bülten aboneliğiniz onaylandı.',
  saved: 'Tercihleriniz hemen kaydedildi.',
  unsubscribed: 'Tüm bültenlerden çıkarıldınız.',
  loading: 'Güvenli bülten sayfası yükleniyor…',
  unavailable: 'Bu bülten sayfası kullanılamıyor veya erişimin süresi dolmuş.',
  chooseTopic: 'En az bir konu seçin.',
  consentRequired: 'Rıza önceden seçili değildir ve açıkça verilmelidir.',
  error: 'İşlem tamamlanamadı. Lütfen daha sonra yeniden deneyin.',
  legalReview: 'Teknik sunum, hizmetin hukuk ve veri koruma incelemesinin yerini almaz.',
  publishLegalTexts: 'Sürümlü hukuk metinlerini yayımla',
  embeddedForm: 'Gömülebilir abonelik formunu etkinleştir',
} as const;

export const newsletterPublicFr = {
  subscribeTitle: 'S’abonner aux newsletters',
  subscribeSubtitle:
    'Choisissez librement les thèmes pour lesquels vous souhaitez recevoir des e-mails.',
  confirmTitle: 'Confirmer l’inscription',
  confirmSubtitle: 'Vérifiez la demande puis confirmez-la expressément.',
  preferencesTitle: 'Préférences newsletter',
  preferencesSubtitle: 'Gérez les thèmes, la langue et le consentement de suivi distinct.',
  email: 'Adresse e-mail',
  language: 'Langue',
  topics: 'Thèmes de newsletter',
  consent: 'Je souhaite recevoir les newsletters sélectionnées et consens comme indiqué.',
  privacyHeading: 'Avis de confidentialité',
  tracking: 'Je consens séparément au suivi individuel des ouvertures et des clics.',
  trackingOptional: 'Ce choix est facultatif et indépendant de l’abonnement.',
  withdrawal: 'Vous pouvez retirer vos choix à tout moment avec la même facilité.',
  noPreselection: 'Aucune option n’est présélectionnée.',
  request: 'Demander l’e-mail de confirmation',
  prepare: 'Ouvrir la confirmation sécurisée',
  confirm: 'Confirmer l’inscription',
  save: 'Enregistrer les préférences',
  unsubscribe: 'Se désabonner de toutes les newsletters',
  unsubscribeConfirm: 'Se désabonner maintenant de toutes les newsletters ?',
  unsubscribeDescription:
    'La modification prend effet immédiatement. Un nouveau double opt-in sera nécessaire pour se réinscrire.',
  cancel: 'Annuler',
  requested:
    'Si les données sont valides, un e-mail contenant uniquement la confirmation a été envoyé. Vérifiez aussi les courriers indésirables.',
  confirmed: 'Votre inscription à la newsletter a été confirmée.',
  saved: 'Vos préférences ont été enregistrées immédiatement.',
  unsubscribed: 'Vous êtes désabonné de toutes les newsletters.',
  loading: 'Chargement de la page newsletter sécurisée…',
  unavailable: 'Cette page est indisponible ou l’accès a expiré.',
  chooseTopic: 'Sélectionnez au moins un thème.',
  consentRequired: 'Le consentement n’est pas présélectionné et doit être donné expressément.',
  error: 'L’action n’a pas pu aboutir. Réessayez plus tard.',
  legalReview:
    'La mise à disposition technique ne remplace pas l’examen juridique et de protection des données.',
  publishLegalTexts: 'Publier les textes juridiques versionnés',
  embeddedForm: 'Activer le formulaire d’inscription intégrable',
} as const;

export const newsletterPublicEs = {
  subscribeTitle: 'Suscribirse a boletines',
  subscribeSubtitle: 'Elija libremente los temas sobre los que desea recibir correos.',
  confirmTitle: 'Confirmar suscripción',
  confirmSubtitle: 'Revise la solicitud y confírmela expresamente.',
  preferencesTitle: 'Preferencias del boletín',
  preferencesSubtitle: 'Gestione temas, idioma y el consentimiento de seguimiento separado.',
  email: 'Correo electrónico',
  language: 'Idioma',
  topics: 'Temas del boletín',
  consent: 'Quiero recibir los boletines seleccionados y consiento según lo descrito.',
  privacyHeading: 'Aviso de privacidad',
  tracking: 'Consiento por separado el seguimiento individual de aperturas y clics.',
  trackingOptional: 'Esta elección es opcional e independiente de la suscripción.',
  withdrawal: 'Puede retirar sus elecciones en cualquier momento con la misma facilidad.',
  noPreselection: 'No hay ninguna opción preseleccionada.',
  request: 'Solicitar correo de confirmación',
  prepare: 'Abrir confirmación segura',
  confirm: 'Confirmar suscripción',
  save: 'Guardar preferencias',
  unsubscribe: 'Cancelar todos los boletines',
  unsubscribeConfirm: '¿Cancelar ahora todos los boletines?',
  unsubscribeDescription:
    'El cambio se aplica inmediatamente. Para volver a suscribirse será necesario un nuevo doble opt-in.',
  cancel: 'Cancelar',
  requested:
    'Si los datos son válidos, se ha enviado un correo solo de confirmación. Revise también el spam.',
  confirmed: 'Su suscripción al boletín ha sido confirmada.',
  saved: 'Sus preferencias se guardaron inmediatamente.',
  unsubscribed: 'Se ha cancelado su suscripción a todos los boletines.',
  loading: 'Cargando la página segura del boletín…',
  unavailable: 'Esta página no está disponible o el acceso ha caducado.',
  chooseTopic: 'Seleccione al menos un tema.',
  consentRequired: 'El consentimiento no está preseleccionado y debe darse expresamente.',
  error: 'No se pudo completar la acción. Inténtelo más tarde.',
  legalReview:
    'La disponibilidad técnica no sustituye la revisión jurídica y de protección de datos.',
  publishLegalTexts: 'Publicar textos jurídicos versionados',
  embeddedForm: 'Activar formulario de suscripción insertable',
} as const;

export const newsletterPublicRu = {
  subscribeTitle: 'Подписка на рассылки',
  subscribeSubtitle: 'Свободно выберите темы, по которым хотите получать письма.',
  confirmTitle: 'Подтвердить подписку',
  confirmSubtitle: 'Проверьте запрос, затем явно подтвердите его.',
  preferencesTitle: 'Настройки рассылки',
  preferencesSubtitle: 'Управляйте темами, языком и отдельным согласием на отслеживание.',
  email: 'Адрес электронной почты',
  language: 'Язык',
  topics: 'Темы рассылки',
  consent: 'Я хочу получать выбранные рассылки и даю согласие на описанных условиях.',
  privacyHeading: 'Уведомление о конфиденциальности',
  tracking: 'Я отдельно соглашаюсь на индивидуальный учёт открытий и переходов.',
  trackingOptional: 'Этот выбор добровольный и не зависит от подписки.',
  withdrawal: 'Вы можете так же легко отозвать свой выбор в любое время.',
  noPreselection: 'Ничего не выбрано заранее.',
  request: 'Запросить письмо для подтверждения',
  prepare: 'Открыть защищённое подтверждение',
  confirm: 'Подтвердить подписку',
  save: 'Сохранить настройки',
  unsubscribe: 'Отписаться от всех рассылок',
  unsubscribeConfirm: 'Отписаться сейчас от всех рассылок?',
  unsubscribeDescription:
    'Изменение действует немедленно. Для повторной подписки потребуется новый double opt-in.',
  cancel: 'Отмена',
  requested:
    'Если данные верны, отправлено письмо только с подтверждением. Проверьте также папку «Спам».',
  confirmed: 'Подписка на рассылку подтверждена.',
  saved: 'Настройки сохранены немедленно.',
  unsubscribed: 'Вы отписаны от всех рассылок.',
  loading: 'Загрузка защищённой страницы рассылки…',
  unavailable: 'Страница недоступна или срок доступа истёк.',
  chooseTopic: 'Выберите хотя бы одну тему.',
  consentRequired: 'Согласие не выбрано заранее и должно быть дано явно.',
  error: 'Не удалось завершить действие. Повторите попытку позже.',
  legalReview: 'Техническая доступность не заменяет юридическую проверку и проверку защиты данных.',
  publishLegalTexts: 'Опубликовать версию юридических текстов',
  embeddedForm: 'Включить встраиваемую форму подписки',
} as const;
